import * as React from "react";
const SvgFiRrPlaneSlash = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-plane-slash_svg__a)">
      <path
        fill="#062147"
        d="m23.707 22.293-6.552-6.552.425-.74H21c.881 0 1.714-.386 2.286-1.058a3.01 3.01 0 0 0 .674-2.44C23.728 10.076 22.41 9 20.894 9h-3.313l-4.258-7.437A3 3 0 0 0 10.69 0c-.863 0-1.68.42-2.183 1.12a2.7 2.7 0 0 0-.358 2.442L9.9 8.485 1.707.293A.999.999 0 1 0 .293 1.707l22 22a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414M12.442 9.665l-2.405-6.757a.68.68 0 0 1 .093-.62c.346-.48 1.147-.297 1.447.251l4.555 7.958A1 1 0 0 0 17 11h3.893c.537 0 1.017.362 1.093.824A1 1 0 0 1 21 13h-4c-.358 0-.69.192-.868.503l-.442.773-3.527-3.527q.087-.075.154-.172a1 1 0 0 0 .125-.91zm2.426 10.073-1.555 2.717A2.99 2.99 0 0 1 10.69 24c-.863 0-1.68-.419-2.183-1.12a2.69 2.69 0 0 1-.363-2.427l1.704-4.788a1 1 0 1 1 1.883.67l-1.698 4.772a.67.67 0 0 0 .1.605c.344.48 1.153.284 1.436-.233l1.565-2.735a.999.999 0 1 1 1.735.994M9 15H6.158l-1.08 1.646A2.99 2.99 0 0 1 2.568 18a2.557 2.557 0 0 1-2.405-3.435l.94-2.564L.157 9.44a2.564 2.564 0 0 1 1.483-3.27 1 1 0 1 1 .715 1.867.56.56 0 0 0-.322.711l1.072 2.907a1 1 0 0 1 0 .69l-1.065 2.91a.55.55 0 0 0 .066.508.54.54 0 0 0 .456.237 1 1 0 0 0 .841-.45L4.78 13.45c.185-.28.5-.45.836-.45h3.382a1 1 0 1 1 0 2z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-plane-slash_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPlaneSlash;
